<template>
  <div class="register" id="register" style="justify-content: flex-start; margin-top: 32px;">
  
    <NavigationBar>
      <template v-slot:left>
        <img v-on:click="goBack" class="back" src="../assets/icons/ic_16_back.svg">
      </template>
      <template v-slot:center>
        {{ $t('register.register') }}
      </template>
      <template v-slot:right>
      </template>
    </NavigationBar>
    
    <div v-if="userSource === 'tff'" style="margin-top: 0px;">
      <h1>{{ $t('register.title_tff') }}</h1>
      <p>{{ $t('register.text_tff') }}</p>
    </div>
    <div v-else style="margin-top: 0px;">
      <h1>{{ $t('register.title') }}</h1>
      <p>{{ $t('register.text') }}</p>
    </div>

    <!-- Single Sign On -->
    <div class="single-sign-on">
      <!-- Apple -->
      <div v-if="!isAndroidApp" class="single-sign-on__button">
        <input v-model="appleLogin" type="checkbox" id="appleLogin" name="appleLogin" @change="loginTypeChecked($event)" />
        <label for="appleLogin" class="single-sign-on__button__content">
          <img src="../assets/icons/ic_20_apple.svg">{{ $t('register.login_with_apple') }}
        </label>
      </div>

      <!-- Google -->
      <div v-if="isAndroidApp" class="single-sign-on__button">
        <input v-model="googleLogin" type="checkbox" id="googleLogin" name="googleLogin" @change="loginTypeChecked($event)" />
        <label for="googleLogin" class="single-sign-on__button__content">
          <img src="../assets/icons/ic_20_google.svg">{{ $t('register.login_with_google') }}
        </label>
      </div>
      <div v-else style="display: flex; justify-content: center;">
        <div id="g_id_onload"
             data-client_id="943145692537-elvlet8tq780g58j60gn8vb130m79eq0.apps.googleusercontent.com"
             data-context="signin"
             data-ux_mode="popup"
             data-callback="handleGoogleLogin"
             data-auto_select="true"
             data-itp_support="true">
        </div>

        <div class="g_id_signin"
             data-type="standard"
             data-shape="rectangular"
             data-theme="outline"
             data-text="signin_with"
             data-size="large"
             data-logo_alignment="left">
        </div>
      </div>
    </div>

    <!-- Divider -->
    <div class="single-sign-on__divider">
      <div></div>
      <span style="text-transform: uppercase">{{ $t('or') }}</span>
      <div></div>
    </div>
    
    <form @submit.prevent="register">

        
        <div class="input-container">

          <div class="input-element" v-bind:class="{ validation_true: nicknameValid === true, validation_false: name.length > 0 && nicknameValid === false }">
            <input v-model="name" type="text" name="name" id="name" placeholder="name" />
            <label for="name">{{ $t('nickname') }}</label>
          </div>

          <div class="input-element" v-bind:class="{ validation_true: emailValid === true, validation_false: email.length > 0 && emailValid === false }" >
            <input @blur="handleEmailBlur" v-model="email" type="email" name="email" id="email" placeholder="email" />
            <label for="email">{{ $t('email') }}</label>
          </div>

          <div class="input-element" v-bind:class="{ validation_true: passwordValid === true, validation_false: password.length > 0 && passwordValid === false }">
            <input v-model="password" type="password" name="password" id="password" placeholder="password" />
            <label for="password">{{ $t('new_password') }}</label>
          </div>

        </div>

        <div v-if="false" class="input-container">

          <div class="input-header">
            {{ $t('register.personal_information') }}
          </div>

          <div class="input-element">
            <select name="landkreis" id="landkreis" v-model="landkreis" required>
              <option value="empty">Keine Angabe</option>
              <option value="Hamburg">Hamburg</option>
            </select>
            <label for="landkreis">Landkreis</label>
          </div>

          <div class="input-element" >
            <input v-model="adresse" type="email" name="adresse" id="adresse" placeholder="adresse" />
            <label for="adresse">Adresse</label>
          </div>

        </div>
      
        <button type="submit" name="button" :disabled="this.emailAlreadyRegistered" style="margin-top: 24px;">
          {{ $t('login_user.register_now') }}
        </button>

    </form>
  
    <ul class="error-container" style="margin-bottom: 20px; list-style-type: none;">
      <li v-for="error in errors">{{ error }}</li>
    </ul>
  
    <div v-if="emailAlreadyRegistered" class="forgot-password">
      <p>
        <span>{{ $t('forgot_password') }} </span>
        <router-link :to="{ name: 'resetpassword', params: { email: this.email }}">{{ $t('reset_password') }}</router-link>
      </p>
      <p>
        <span>{{ $t('create_betgame.teamtip_account_exists') }} </span>
        <router-link :to="{ name: 'login', params: { email: this.email }}">{{ $t('login') }}</router-link>
      </p>
    </div>
    
  </div>
</template>

<script>
  
  import APIService from '@/services/APIService'
  import NavigationBar from './../components/NavigationBar'
  import Numeral from 'numeral'
  import moment from 'moment'
  
export default {
  name: 'registeruser',
  components: { NavigationBar },
  props: {
    emailparam: {
      type: String,
      default: ''
    },
    passparam: {
      type: String,
      default: ''
    },
    nameparam: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      name: this.nameparam,
      email: this.emailparam,
      password: this.passparam,
      errors: [],
      emailAlreadyRegistered: false,
      agreedTOS: false,
      isUnder18: false,
      appleLogin: false,
      googleLogin: false
    }
  },
  created() {
    if(!this.isAndroidApp) {
      const rureloaded = localStorage.getItem('rureloaded');
      if (rureloaded !== 'true') {
        localStorage.setItem('rureloaded', 'true');
        location.reload();
      }
    }
  },
  mounted() {
    window.handleGoogleLogin = function(token) {
      window.localStorage.setItem('gatoken', token.credential)
      window.location.href = '/googleauth?token=' + token.credential
    }
  },
  computed: {
    isAndroidApp() {
      return window.AndroidBridge && window.AndroidBridge.signInWithGoogle
    },
    userlang () {
      return this.$store.state.language
    },
    userSource() {
      return window.localStorage.getItem('userSource') || ''
    },
    nicknameValid () {
      if(this.name === null || this.name === undefined) {
        return false
      }
      return this.name.length >= 3
    },
    emailValid () {
      if(this.email === null || this.email === undefined) {
        return false
      }
      const valid = this.isValidEmail(this.email)
      return valid
      /*
      if(valid) {
        APIService.isEmailRegistered(this.email).then(response => {
          if (response.data.valid === '1') {
            this.emailAlreadyRegistered = false
            this.errors = this.errors.filter(e => e !== this.$t('errors.email_already_registered'))
            return true
          } else {
            this.emailAlreadyRegistered = true
            if(!this.errors.includes(this.$t('errors.email_already_registered'))) {
              this.errors.push(this.$t('errors.email_already_registered'))
            }
            return false
          }
        })
      } else {
        this.errors = this.errors.filter(e => e !== this.$t('errors.email_already_registered'))
        return valid
      }
       */
    },
    passwordValid () {
      if(this.password === null || this.password === undefined) {
        return false
      }
      return this.password.length > 6
    }
  },
  methods: {
    loginTypeChecked(event) {
      if(event.target.id === 'appleLogin') {
        this.appleLogin = event.target.checked
        if(this.appleLogin) {
          this.googleLogin = false
        }
        this.registerApple()
      } else if(event.target.id === 'googleLogin') {
        this.googleLogin = event.target.checked
        if(this.googleLogin) {
          this.appleLogin = false
        }
        this.registerGoogle()
      }
    },
    handleEmailBlur() {
      if(!this.isNullOrUndefined(this.email) && this.isValidEmail(this.email)) {
        const that = this
        APIService.isEmailRegistered(this.email.toLowerCase().trim()).then(response => {
          if (response.data.valid === '1') {
            that.emailAlreadyRegistered = false
            that.errors = that.errors.filter(e => e !== that.$t('errors.email_already_registered'))
          } else {
            that.emailAlreadyRegistered = true
            if (!that.errors.includes(that.$t('errors.email_already_registered'))) {
              that.errors.push(that.$t('errors.email_already_registered'))
            }
          }
        })
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    registerApple() {
      const clientId = 'net.teamtip.app'; // Deine Service-ID von Apple
      const redirectURI = 'https://teamtip.net/auth/apple'; // Backend Redirect

      const url = `https://appleid.apple.com/auth/authorize?` +
        `response_type=code%20id_token` +
        `&client_id=${encodeURIComponent(clientId)}` +
        `&redirect_uri=${encodeURIComponent(redirectURI)}` +
        `&scope=name%20email` +
        `&response_mode=form_post`;

      window.location.href = url;
    },
    registerGoogle() {
      // If running inside the Android WebView, call the bridge.
      if (window.AndroidBridge && window.AndroidBridge.signInWithGoogle) {
        window.AndroidBridge.signInWithGoogle();
      } else {
        // Fallback if opened in a normal browser:
        // redirect to your backend’s OAuth start, which should use Google OAuth on web.
        alert('Login with Google failed: 0002')
        // window.location.href = '/auth/google/start';
      }
    },
    register() {
      if(this.isApp() && this.appleLogin) {
        this.registerApple()
        return
      } else if(this.isApp() && this.googleLogin) {
        this.registerGoogle()
        return
      }
      this.errors = []
      this.emailAlreadyRegistered = false
      if(this.isNullOrUndefined(this.name)) {
        this.errors.push(this.$i18n.t('errors.enter_nickname'))        
      } else if(this.name.length === 0) {
        this.errors.push(this.$i18n.t('errors.enter_nickname'))
      } else if(this.name.length > 100) {
        this.errors.push(this.$i18n.t('errors.enter_nickname_length'))
      }
      if(this.isNullOrUndefined(this.email)) {
        this.errors.push(this.$i18n.t('errors.enter_email'))        
      } else if(this.email.length === 0) {
        this.errors.push(this.$i18n.t('errors.enter_email'))
      } else if(this.email.length > 100) {
        this.errors.push(this.$i18n.t('errors.enter_email'))
      } else if(!this.isValidEmail(this.email)) {
        this.errors.push(this.$i18n.t('errors.enter_valid_email'))
      }
      if(this.isNullOrUndefined(this.password) || this.password.length === 0 || this.password.length > 100) {
        this.errors.push(this.$i18n.t('errors.enter_password_length'))
      }
      //if (!this.agreedTOS) {
      //  this.errors.push(this.$i18n.t('errors.confirm_terms_of_use'))
      //}
      if (this.errors.length === 0) {
        APIService.isEmailRegistered(this.email.toLowerCase().trim()).then(response => {
          if (response.data.valid === '1') {
            const language = this.$store.state.language ? this.$store.state.language : 'de'
            this.$store.dispatch('register', {
              nick: this.name,
              email: this.email.toLowerCase().trim(),
              pass: this.password,
              lang: language,
              source: this.$store.state.userSource || this.getBGValue('spmic') || '',
              fk_betgame: this.getBGValue('spmbgid')
            })
            .then(() => {
              //this.$store.dispatch('patchUser', {acceptedtos: this.agreedTOS, isadult: !this.isUnder18}).then(() => {
              //})
              const uid = '' + this.$store.state.user.id
              const uem = '' + this.$store.state.user.email.charAt(0) + this.reverse(uid)
              const temp = this.reverse(String(this.$store.state.user.registration_date)).replaceAll('T', this.reverse(uem))
              .replaceAll(':', '').replaceAll('-', uem).concat(uid)
              const data = {
                '_id': uid,
                'first_name': this.$store.state.user.nickname,
                'email': this.$store.state.user.email.toLowerCase().trim(),
                'password': temp
              }
              this.$store.dispatch('chatCreateUser', data).then(response => {
                this.$store.dispatch('chatLoginUser', {'user': data._id, 'password': data.password}).then(response => {
                  this.$store.dispatch('patchUser', {
                    chatuser: uid + '-' + temp
                  })
                })
                .catch(function (error) {
                })
              })
              .catch(function (error) {
              })
              if(this.$store.state.language !== undefined && this.$store.state.language !== null &&
                  this.$store.state.language.length > 1) {
                Numeral.locale(this.$store.state.language)
                moment.locale(this.$store.state.language)
              }
              if(this.$store.state.language !== undefined && this.$store.state.language !== null &&
                  this.$store.state.language.length > 1 && this.$i18n.locale !== this.$store.state.language) {
                this.$i18n.locale = this.$store.state.language
              }
              this.setBGValue('spmic', '')
              const bgid = this.getBGValue('spmbgid')
              if(bgid !== undefined && bgid !== null && this.isNumeric(bgid) && bgid > 0) {
                this.$store.dispatch('userEnterBetgame', bgid).then(() => {
                  this.$router.push('/feed/dashboard')
                })
              } else {
                this.$router.push('/mybetgames')
              }
            }).catch(function (error) {
              if (error.response.status === 409) {
                alert(this.$t('errors.email_already_registered'))
              } else {
                alert(this.$t('errors.registration_failed'))
              }
            })
          } else {
            this.emailAlreadyRegistered = true
            this.errors.push(this.$t('errors.email_already_registered'))
          }
        })
      }
    },
    isNullOrUndefined(data) {
      return data === null || data === undefined
    },
    isValidEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return !this.emailAlreadyRegistered && re.test(String(email).toLowerCase());
    }
  }
}
</script>

<style lang="scss" scoped>
  .register {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: calc(100vh - 64px);
    padding: 64px 16px 0 16px;
    max-width: 400px;
    margin: 0px auto;

    h1 {
      text-align: center;
    }
    p {
      text-align: center;
      margin-bottom: 26px;
    }
  }
  .forgot-password {
    width: 100%;
    text-align: center;
    color: $colorGreyDark;
    padding: 20px 0;
  
    a {
      font-weight: 500;
      text-decoration: none;
      margin-left: 6px;
      padding: 12px 0;
    }
  
    p {
      margin-bottom: 16px;
    }
  }
  .input-container {
    margin: 0 auto;
  }

  .single-sign-on {

    &__divider {
      display: flex;
      align-items: center;
      width: 100%;
      margin: 24px 0;

      span {
        font-size: 14px;
        color: rgba($colorGreyDark, .48);
        margin: 0 8px;
      }

      div {
        height: 1px;
        width: 100%;
        background: linear-gradient(90deg, $colorGreyDark 0%, rgba($colorGreyDark, 0) 100%);
        opacity: .12;

        &:first-of-type {
          background: linear-gradient(90deg, rgba($colorGreyDark, 0) 0%, $colorGreyDark 100%);
        }
      }
    }

    &__button {
      display: flex;
      width: 100%;

      &:not(:last-child) {
        margin-bottom: 8px;
      }

      &__content {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        background: $colorWhite;
        border-radius: 8px;
        padding: 16px;
        font-size: 17px;
        color: $colorGreyDark;
        box-shadow: 0 0 0 1px rgba($colorGreyDark, .08);
        transition: all .2s ease-in-out;

        &:hover {
          box-shadow: 0 0 0 1px rgba($colorGreyDark, .16);
        }

        img {
          width: 20px;
          height: 20px;
          margin-right: 8px;
        }
      }

      input {
        display: none;

        &:checked ~ label {
          box-shadow: 0 0 0 2px $colorPrimary;
        }
      }
    }
  }

  .registerlegal {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 32px 0;

    &__checkbox {
      display: flex;
      align-items: center;

      &:not(:last-of-type) {
        margin-bottom: 16px;
      }

      input {
        display: none;
      }

      label {
        position: relative;
        font-size: 14px;
        letter-spacing: -0.41px;
        font-weight: 400;
        color: rgba($colorGreyDark, .64);
        padding-left: 32px;

        &:before {
          content: '';
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: 0;
          width: 20px;
          height: 20px;
          background: url('../assets/icons/ic_20_checkbox.svg');
        }

        a {
          color: rgba($colorGreyDark, .64);
        }
      }

      input[type="checkbox"]:checked+label:before {
        background: url('../assets/icons/ic_20_checkbox_active.svg');
      }
    }
  }
</style>
